export const CS_AUTH0_CLIENT_CONNECTION = 'highmark-internal-enterprise-saml';
